import React from 'react';
import { connect } from 'react-redux';
import { logoutAction } from '../../../actions/session';

const LogoutLink = ({ logoutAction }) => (
    <a
        href="javascript:void(0)"
        onClick={() => { logoutAction() }}
        className="dropdown-item">
            <i className="fas fa-sign-out-alt" />
            <span>Sair</span>
    </a>
);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
    logoutAction
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutLink);


// WEBPACK FOOTER //
// ./src/components/Layout/Topbar/LogoutLink.js